
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g8FokUAsKfkx9vuGKCwpBIy0ANkSCEFFpLbnp7zhuICQMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexgXC3Y0zrlFHztfudgffs4_PVaSnRe2ST_45cIfAlsgscIMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchJZ_WEzDuR0hJOlbmRbRbrUTER0GYPwzZm9wy4YYqq_458Meta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexZUuKTjelARUbHA2g4w1GohgEw4MTB5tClCH4YOA3b3sMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93h9jfHQS9_45rAqNEzlb67HRDzyJyBhMomdwVn9TyEF10EMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexL6sgiFhEBe3bk0k8U1Jh97h9cPUA_HYTgX8KOPOQ8VEMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93rAf0aMYTmjJ_yh_VClf_7sBhsn2ce6mTClCTehbx_45DcMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexlktWiUgqQCAppsjoWRLzmobPn423mbSzxNIO5DRhxLoMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93d99gS22WGgIyK_45RzEZ4Oh9eCNa71RSVIn_POcpyW3sQMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indextRm9GpF7oJLTEwHEcHxG0ahw7CHNHb_pkNpFzDZmkF0Meta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexqD7CREQ9vUJuzTqcF2TwaD0wCjuT2WUQoX0xPWjPvJAMeta } from "/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexL6sgiFhEBe3bk0k8U1Jh97h9cPUA_HYTgX8KOPOQ8VEMeta || {},
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexlktWiUgqQCAppsjoWRLzmobPn423mbSzxNIO5DRhxLoMeta || {},
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indextRm9GpF7oJLTEwHEcHxG0ahw7CHNHb_pkNpFzDZmkF0Meta || {},
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexqD7CREQ9vUJuzTqcF2TwaD0wCjuT2WUQoX0xPWjPvJAMeta || {},
    component: () => import("/codebuild/output/src1387072141/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]